module.exports = __webpack_public_path__ + "img/logo-pertahanan-smaller.3f7f26ae.png";